import {
  AreaChart,
  Area,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

interface PortfolioPerformanceChartProps {
  data: { date: string; value: number }[];
}

export const PortfolioPerformanceChart = ({
  data,
}: PortfolioPerformanceChartProps) => {
  const xInterval =
    data.length <= 10 ? 0 : Math.max(0, Math.floor(data.length / 10));
  return (
    <div className="h-64 w-full min-h-[220px]">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={data}
          margin={{ top: 8, right: 8, left: 8, bottom: 32 }}>
          <defs>
            <linearGradient id="portfolioGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#818cf8" stopOpacity={0.9} />
              <stop offset="95%" stopColor="#818cf8" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis
            dataKey="date"
            stroke="#94a3b8"
            tickLine={false}
            axisLine={false}
            tick={{ fontSize: 11 }}
            interval={xInterval}
          />
          <YAxis
            stroke="#94a3b8"
            tickLine={false}
            axisLine={false}
            width={44}
            tick={{ fontSize: 11 }}
            tickFormatter={(value) => `${value.toLocaleString()} $`}
          />
          <Tooltip
            contentStyle={{
              background: "rgba(15,23,42,0.95)",
              borderRadius: "12px",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#fff",
            }}
            labelStyle={{ color: "#fff" }}
            itemStyle={{ color: "#fff" }}
            formatter={(value: number) => [
              `${value.toLocaleString()} $`,
              "Valeur",
            ]}
          />
          <Area
            type="monotone"
            dataKey="value"
            stroke="#a5b4fc"
            strokeWidth={2}
            fill="url(#portfolioGradient)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};
